import {
  ContentArea,
  HeroFrontpageMaximum,
  HeroFrontpageMedium,
  HeroFrontpageMinimum,
  PromoTextBlock,
} from "/App.Components";
import { ContentAreaType } from "/Models/Generated/ContentAreaType";
import "./Frontpage.scss";
import { FrontpageProps } from "/Models/Generated/FrontpageProps";
import { NoradTheme } from "/Models/Generated/NoradTheme";
import React from "react";
import { HasContent } from "../../Shared/ContentArea/ContentArea";
import { ContentAreaItemMargin } from "../../Shared/ContentAreaItem/ContentAreaItem";

const Frontpage = ({ hiddenH1, heroes, promoTextBlock, contentArea }: FrontpageProps) => (
  <div className="frontpage-norad">
    {hiddenH1 && <h1 className="frontpage-norad__hidden-h1">{hiddenH1}</h1>}
    {heroes &&
      heroes.map((hero, idx) => (
        <React.Fragment key={idx}>
          {hero && hero.theme === NoradTheme.Primary && (
            <HeroFrontpageMaximum {...hero} />
          )}
          {hero && hero.theme === NoradTheme.Secondary && (
            <HeroFrontpageMedium {...hero} />
          )}
          {hero && hero.theme === NoradTheme.Ternary && (
            <HeroFrontpageMinimum {...hero} />
          )}
        </React.Fragment>
      ))}
    {promoTextBlock && <PromoTextBlock {...promoTextBlock} />}
    {HasContent(contentArea) && (
      <div className="frontpage-norad__content-area-container">
        <ContentArea
          {...contentArea}
          contentAreaType={ContentAreaType.FullWidth}
          margin={ContentAreaItemMargin.Huge}
        />
      </div>
    )}
  </div>
);

export default Frontpage;
